import { cn } from "@/lib/utils";
import type { CSSProperties, ReactNode } from "react";

type BlogBoardFrameProps = {
  title?: ReactNode;
  caption?: ReactNode;
  children: ReactNode;
  className?: string;
  cardClassName?: string;
  cardStyle?: CSSProperties;
};

/**
 * Shared chrome for chessboards embedded in articles. The title is optional so
 * a board without editorial context does not get an empty header, while the
 * caption always stays in the article flow below the viewer.
 */
export default function BlogBoardFrame({
  title,
  caption,
  children,
  className,
  cardClassName,
  cardStyle,
}: BlogBoardFrameProps) {
  return (
    <figure className={cn("w-full my-8 not-prose", className)}>
      <div
        className={cn(
          "w-full overflow-hidden rounded-md md:w-fit bg-athens-gray-150",
          cardClassName,
        )}
        style={cardStyle}
      >
        {title && (
          <div className="flex items-center min-h-[48px] px-4 text-base font-bold leading-snug text-chess-ui-control bg-chess-ui-header">
            {title}
          </div>
        )}
        {children}
      </div>
      {caption && (
        <figcaption className="w-full mt-3 text-sm italic leading-relaxed text-left text-chess-ui-muted">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}

export const blogBoardControlClass =
  "text-altblue-500 bg-chess-ui-control hover:bg-chess-ui-surface disabled:text-chess-ui-disabled";
